export default __webpack_public_path__ + "static/media/fondo_mega_menu_vitality.47d84269.jpg";